// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mabosstiff: PokeData = {
  "id": 943,
  "name": "mabosstiff",
  "height": 11,
  "weight": 610,
  "base_experience": 177,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "double-edge",
    "leer",
    "bite",
    "roar",
    "lick",
    "reversal",
    "scary-face",
    "outrage",
    "swagger",
    "crunch",
    "payback",
    "hone-claws",
    "snarl",
    "jaw-lock",
    "comeuppance"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "leer",
    "bite",
    "lick",
    "scary-face",
    "outrage",
    "crunch",
    "snarl",
    "pursuit",
    "quash",
    "snatch",
    "phantom-force"
  ],
  "evolution_chain": {
    "id": 493,
    "item": null,
    "species": [
      {
        "name": "maschiff",
        "order": 972,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "mabosstiff",
        "order": 973,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": 942,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 119,
    "ability_power": 168
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
